import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../../../Router/all_routes";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";

const Homepage = () => {
  const route = all_routes;
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/signin");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="main-wrapper">
      {/* Header Section */}
      <div className="homepage-header">
        <div className="container-fluid">
          <div className="row align-items-center py-3">
            <div className="col-lg-3 col-md-4">
              <div className="homepage-logo">
                <ImageWithBasePath src="assets/img/logo.png" alt="Logo" />
              </div>
            </div>
            <div className="col-lg-6 col-md-4 text-center">
              <h2 className="mb-0">Style Buzz Pro</h2>
            </div>
            <div className="col-lg-3 col-md-4 text-end">
              <Link to={route.signin} className="btn btn-primary">
                <i className="ti ti-login me-2"></i>Sign In
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Hero Section */}
      <div className="homepage-hero bg-light py-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 text-center">
              <h1 className="display-4 mb-3">
                Complete Salon Management Solution
              </h1>
              <p className="lead mb-4">
                Streamline your billing, appointments, inventory, and staff
                management
              </p>
              <div className="d-flex justify-content-center gap-3">
                <Link to={route.signin} className="btn btn-primary btn-lg">
                  Get Started
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Key Features - Billing Focused */}
      <div className="homepage-features py-5">
        <div className="container">
          <div className="row mb-4">
            <div className="col-lg-12 text-center">
              <h2 className="mb-3">Billing & Management Features</h2>
              <p className="text-muted">
                Everything you need to run your salon business efficiently
              </p>
            </div>
          </div>

          <div className="row g-4">
            {/* Feature 1 - Billing */}
            <div className="col-lg-4 col-md-6">
              <div className="card feature-card h-100 border-0 shadow-sm">
                <div className="card-body text-center p-4">
                  <div className="feature-icon mb-3">
                    <i
                      className="ti ti-receipt-2 text-primary"
                      style={{ fontSize: "3rem" }}
                    ></i>
                  </div>
                  <h4 className="mb-3">Quick Billing</h4>
                  <p className="text-muted">
                    Generate invoices instantly with automated tax calculations
                    and multiple payment options
                  </p>
                </div>
              </div>
            </div>

            {/* Feature 2 - Appointments */}
            <div className="col-lg-4 col-md-6">
              <div className="card feature-card h-100 border-0 shadow-sm">
                <div className="card-body text-center p-4">
                  <div className="feature-icon mb-3">
                    <i
                      className="ti ti-calendar-event text-success"
                      style={{ fontSize: "3rem" }}
                    ></i>
                  </div>
                  <h4 className="mb-3">Appointment Management</h4>
                  <p className="text-muted">
                    Schedule and manage customer appointments with automated
                    reminders
                  </p>
                </div>
              </div>
            </div>

            {/* Feature 3 - Inventory */}
            <div className="col-lg-4 col-md-6">
              <div className="card feature-card h-100 border-0 shadow-sm">
                <div className="card-body text-center p-4">
                  <div className="feature-icon mb-3">
                    <i
                      className="ti ti-package text-warning"
                      style={{ fontSize: "3rem" }}
                    ></i>
                  </div>
                  <h4 className="mb-3">Inventory Control</h4>
                  <p className="text-muted">
                    Track products and supplies with low-stock alerts and
                    automated reordering
                  </p>
                </div>
              </div>
            </div>

            {/* Feature 4 - Staff Management */}
            <div className="col-lg-4 col-md-6">
              <div className="card feature-card h-100 border-0 shadow-sm">
                <div className="card-body text-center p-4">
                  <div className="feature-icon mb-3">
                    <i
                      className="ti ti-users text-info"
                      style={{ fontSize: "3rem" }}
                    ></i>
                  </div>
                  <h4 className="mb-3">Staff Management</h4>
                  <p className="text-muted">
                    Manage employee schedules, attendance, and performance
                    tracking
                  </p>
                </div>
              </div>
            </div>

            {/* Feature 5 - Reports */}
            <div className="col-lg-4 col-md-6">
              <div className="card feature-card h-100 border-0 shadow-sm">
                <div className="card-body text-center p-4">
                  <div className="feature-icon mb-3">
                    <i
                      className="ti ti-chart-bar text-danger"
                      style={{ fontSize: "3rem" }}
                    ></i>
                  </div>
                  <h4 className="mb-3">Business Reports</h4>
                  <p className="text-muted">
                    Comprehensive reports on sales, expenses, and profit margins
                  </p>
                </div>
              </div>
            </div>

            {/* Feature 6 - Multi-Store */}
            <div className="col-lg-4 col-md-6">
              <div className="card feature-card h-100 border-0 shadow-sm">
                <div className="card-body text-center p-4">
                  <div className="feature-icon mb-3">
                    <i
                      className="ti ti-building-store text-purple"
                      style={{ fontSize: "3rem" }}
                    ></i>
                  </div>
                  <h4 className="mb-3">Multi-Store Support</h4>
                  <p className="text-muted">
                    Manage multiple salon locations from a single dashboard
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Pricing Section */}
      <div className="homepage-pricing py-5">
        <div className="container">
          <div className="row mb-5">
            <div className="col-lg-12 text-center">
              <h2 className="mb-3">Simple, Transparent Pricing</h2>
              <p className="text-muted">
                Choose the plan that fits your business needs
              </p>
            </div>
          </div>

          <div className="row g-4">
            {/* Starter Plan */}
            <div className="col-lg-4 col-md-6">
              <div className="card pricing-card h-100 border-0 shadow">
                <div className="card-body p-4">
                  <div className="text-center mb-4">
                    <h4 className="mb-3">Starter</h4>
                    <div className="pricing-amount mb-3">
                      <span className="display-4 fw-bold">₹2,499</span>
                      <span className="text-muted">/month</span>
                    </div>
                    <p className="text-muted">Perfect for small salons</p>
                  </div>
                  <ul className="list-unstyled mb-4">
                    <li className="mb-3">
                      <i className="ti ti-check text-success me-2"></i>
                      Up to 2 staff members
                    </li>
                    <li className="mb-3">
                      <i className="ti ti-check text-success me-2"></i>
                      100 customers
                    </li>
                    <li className="mb-3">
                      <i className="ti ti-check text-success me-2"></i>
                      Basic billing & invoicing
                    </li>
                    <li className="mb-3">
                      <i className="ti ti-check text-success me-2"></i>
                      Appointment scheduling
                    </li>
                    <li className="mb-3">
                      <i className="ti ti-check text-success me-2"></i>
                      Email support
                    </li>
                    <li className="mb-3 text-muted">
                      <i className="ti ti-x me-2"></i>
                      Inventory management
                    </li>
                    <li className="mb-3 text-muted">
                      <i className="ti ti-x me-2"></i>
                      Advanced reports
                    </li>
                  </ul>
                  <Link
                    to={route.register}
                    className="btn btn-outline-primary w-100"
                  >
                    Get Started
                  </Link>
                </div>
              </div>
            </div>

            {/* Professional Plan */}
            <div className="col-lg-4 col-md-6">
              <div className="card pricing-card pricing-featured h-100 border-0 shadow-lg">
                <div className="pricing-badge">
                  <span className="badge bg-primary">Most Popular</span>
                </div>
                <div className="card-body p-4">
                  <div className="text-center mb-4">
                    <h4 className="mb-3">Professional</h4>
                    <div className="pricing-amount mb-3">
                      <span className="display-4 fw-bold">₹6,499</span>
                      <span className="text-muted">/month</span>
                    </div>
                    <p className="text-muted">For growing businesses</p>
                  </div>
                  <ul className="list-unstyled mb-4">
                    <li className="mb-3">
                      <i className="ti ti-check text-success me-2"></i>
                      Up to 10 staff members
                    </li>
                    <li className="mb-3">
                      <i className="ti ti-check text-success me-2"></i>
                      Unlimited customers
                    </li>
                    <li className="mb-3">
                      <i className="ti ti-check text-success me-2"></i>
                      Advanced billing & invoicing
                    </li>
                    <li className="mb-3">
                      <i className="ti ti-check text-success me-2"></i>
                      Appointment scheduling
                    </li>
                    <li className="mb-3">
                      <i className="ti ti-check text-success me-2"></i>
                      Priority support
                    </li>
                    <li className="mb-3">
                      <i className="ti ti-check text-success me-2"></i>
                      Inventory management
                    </li>
                    <li className="mb-3">
                      <i className="ti ti-check text-success me-2"></i>
                      Advanced reports
                    </li>
                  </ul>
                  <Link to={route.register} className="btn btn-primary w-100">
                    Get Started
                  </Link>
                </div>
              </div>
            </div>

            {/* Enterprise Plan */}
            <div className="col-lg-4 col-md-6">
              <div className="card pricing-card h-100 border-0 shadow">
                <div className="card-body p-4">
                  <div className="text-center mb-4">
                    <h4 className="mb-3">Enterprise</h4>
                    <div className="pricing-amount mb-3">
                      <span className="display-4 fw-bold">₹16,499</span>
                      <span className="text-muted">/month</span>
                    </div>
                    <p className="text-muted">For multiple locations</p>
                  </div>
                  <ul className="list-unstyled mb-4">
                    <li className="mb-3">
                      <i className="ti ti-check text-success me-2"></i>
                      Unlimited staff members
                    </li>
                    <li className="mb-3">
                      <i className="ti ti-check text-success me-2"></i>
                      Unlimited customers
                    </li>
                    <li className="mb-3">
                      <i className="ti ti-check text-success me-2"></i>
                      Advanced billing & invoicing
                    </li>
                    <li className="mb-3">
                      <i className="ti ti-check text-success me-2"></i>
                      Multi-store support
                    </li>
                    <li className="mb-3">
                      <i className="ti ti-check text-success me-2"></i>
                      24/7 dedicated support
                    </li>
                    <li className="mb-3">
                      <i className="ti ti-check text-success me-2"></i>
                      Full inventory management
                    </li>
                    <li className="mb-3">
                      <i className="ti ti-check text-success me-2"></i>
                      Custom reports & analytics
                    </li>
                  </ul>
                  <Link
                    to={route.register}
                    className="btn btn-outline-primary w-100"
                  >
                    Contact Sales
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Stats Section */}
      <div className="homepage-stats bg-primary text-white py-5">
        <div className="container">
          <div className="row text-center">
            <div className="col-lg-3 col-md-6 mb-4 mb-lg-0">
              <div className="stat-item">
                <h2 className="display-4 mb-2">500+</h2>
                <p className="mb-0">Active Salons</p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 mb-4 mb-lg-0">
              <div className="stat-item">
                <h2 className="display-4 mb-2">10K+</h2>
                <p className="mb-0">Invoices Generated</p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 mb-4 mb-lg-0">
              <div className="stat-item">
                <h2 className="display-4 mb-2">99.9%</h2>
                <p className="mb-0">Uptime</p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="stat-item">
                <h2 className="display-4 mb-2">24/7</h2>
                <p className="mb-0">Support</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="homepage-cta py-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 text-center">
              <h2 className="mb-3">Ready to Transform Your Salon Business?</h2>
              <p className="lead mb-4">
                Start your free trial today and experience the difference
              </p>
              <Link to={route.signin} className="btn btn-primary btn-lg">
                Start Free Trial
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="homepage-footer bg-dark text-white py-4">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 text-center">
              <p className="mb-0">
                © 2025 Style Buzz Pro. All rights reserved.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Homepage;
